import { setupAutoLogout, clearAutoLogout } from './authUtils';
import store from '../redux/store';
import { logout } from '../redux/userSlice';

export const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const country = localStorage.getItem('countryOverride');

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...(country && { 'X-User-Country': country }),
      ...options.headers,
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  });

  // Pick up refreshed token (sliding session)
  const newToken = response.headers.get('X-Refreshed-Token');
  if (newToken) {
    localStorage.setItem('token', newToken);
    setupAutoLogout(store, newToken);
  }

  // Handle auth errors
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem('token');
    clearAutoLogout();
    store.dispatch(logout());
    window.location.href = '/signin';
    throw new Error('Session expired. Please sign in again.');
  }

  return response;
};
